export const OFFLINE_CACHE_BUSTER = 'financego-phase-11-v2';

export function shouldPersistOfflineQuery(query: {
  readonly queryKey: readonly unknown[];
  readonly state: { readonly data?: unknown; readonly status: string };
}): boolean {
  return isOfflineSafeQuery(query.queryKey) && query.state.data !== undefined;
}

function isOfflineSafeQuery(queryKey: readonly unknown[]): boolean {
  if (queryKey[0] === 'finance') return true;
  return queryKey[0] === 'account' && queryKey[1] === 'current-user';
}
